import { AritoIcon, AritoFormV2, DialogV2 } from '@/components/custom/erp';
import { editPrintTemplateSchema, initialValues } from './schema';
import { Button } from '@/components/ui/button';

import { EditPrintTemplateBasicInfo } from './tabs';

interface EditPrintTemplateDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: BanHangPayload) => void;
}

export const EditPrintTemplateDialog: React.FC<EditPrintTemplateDialogProps> = ({ open, onClose, onSave }) => {
  const handleSubmit = (data: BanHangPayload) => {
    onSave(data);
    onClose();
  };

  const handleSaveClick = () => {
    const form = document.querySelector('form');
    if (form) {
      form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title=''
      maxWidth='md'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
      actions={
        <>
          <Button onClick={handleSaveClick} className='bg-main text-white hover:bg-main-dark'>
            <AritoIcon icon={884} />
            <span className='ml-1'>Đồng ý</span>
          </Button>
          <Button onClick={onClose} variant='outline'>
            <AritoIcon icon={885} />
            <span className='ml-1'>Huỷ</span>
          </Button>
        </>
      }
    >
      <div className='w-[800px] min-w-[800px]'>
        <AritoFormV2
          mode='add'
          hasAritoActionBar={false}
          schema={editPrintTemplateSchema}
          initialData={initialValues}
          onSubmit={handleSubmit}
          className='w-full'
          headerFields={<EditPrintTemplateBasicInfo />}
        />
      </div>
    </DialogV2>
  );
};
export default EditPrintTemplateDialog;
